// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-split {
    position: relative;
    height: 100%;
    width: 100%;
}

.react-split--vertical > .split__pane {
    overflow: hidden;
    height: 100%;
    display: inline-block;
    vertical-align: top;
}

.react-split--vertical > .split__pane:not(:last-child) {
    padding-right: 4px;
    box-sizing: border-box;
}

/* Tabs bar should span the full pane width, not the inset content area */
.react-split--vertical > .split__pane:not(:last-child) .tabs__bar {
    margin-right: -4px;
}

.react-split--horizontal > .split__pane {
    overflow: hidden;
    width: 100%;
    display: block;
}

.react-split--horizontal > .split__pane:not(:last-child) {
    padding-bottom: 4px;
    box-sizing: border-box;
}

/* Sash hit area */

.react-split__sash {
    position: absolute;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.react-split__sash--vertical {
    top: 0;
    width: 9px !important;
    height: 100%;
    cursor: col-resize;
}

.react-split__sash--horizontal {
    left: 0;
    height: 9px !important;
    width: 100%;
    cursor: row-resize;
}

.react-split__sash--disabled {
    pointer-events: none;
}

/* Sash visual indicator */

.split-sash-content {
    flex-shrink: 0;
    background: transparent;
    transition: background 0.1s;
}

.react-split__sash--vertical .split-sash-content {
    width: 1px;
    height: 100%;
    background: var(--color-border);
}

.react-split__sash--horizontal .split-sash-content {
    height: 1px;
    width: 100%;
    background: var(--color-border);
}

/* Hover and active — accent highlight, slightly thicker */

@media (pointer: fine) {
    .react-split__sash--vertical .split-sash-content-active,
    .react-split__sash--vertical:hover .split-sash-content {
        width: 2px;
        background: var(--color-accent);
    }
}

@media (pointer: fine) {
    .react-split__sash--horizontal .split-sash-content-active,
    .react-split__sash--horizontal:hover .split-sash-content {
        height: 2px;
        background: var(--color-accent);
    }
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/Split/s.split.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,yEAAyE;AACzE;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,kBAAkB;;AAElB;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,MAAM;IACN,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,0BAA0B;;AAE1B;IACI,cAAc;IACd,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,+BAA+B;AACnC;;AAEA,0DAA0D;;AAE1D;IACI;;QAEI,UAAU;QACV,+BAA+B;IACnC;AACJ;;AAEA;IACI;;QAEI,WAAW;QACX,+BAA+B;IACnC;AACJ","sourcesContent":[".react-split {\n    position: relative;\n    height: 100%;\n    width: 100%;\n}\n\n.react-split--vertical > .split__pane {\n    overflow: hidden;\n    height: 100%;\n    display: inline-block;\n    vertical-align: top;\n}\n\n.react-split--vertical > .split__pane:not(:last-child) {\n    padding-right: 4px;\n    box-sizing: border-box;\n}\n\n/* Tabs bar should span the full pane width, not the inset content area */\n.react-split--vertical > .split__pane:not(:last-child) .tabs__bar {\n    margin-right: -4px;\n}\n\n.react-split--horizontal > .split__pane {\n    overflow: hidden;\n    width: 100%;\n    display: block;\n}\n\n.react-split--horizontal > .split__pane:not(:last-child) {\n    padding-bottom: 4px;\n    box-sizing: border-box;\n}\n\n/* Sash hit area */\n\n.react-split__sash {\n    position: absolute;\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.react-split__sash--vertical {\n    top: 0;\n    width: 9px !important;\n    height: 100%;\n    cursor: col-resize;\n}\n\n.react-split__sash--horizontal {\n    left: 0;\n    height: 9px !important;\n    width: 100%;\n    cursor: row-resize;\n}\n\n.react-split__sash--disabled {\n    pointer-events: none;\n}\n\n/* Sash visual indicator */\n\n.split-sash-content {\n    flex-shrink: 0;\n    background: transparent;\n    transition: background 0.1s;\n}\n\n.react-split__sash--vertical .split-sash-content {\n    width: 1px;\n    height: 100%;\n    background: var(--color-border);\n}\n\n.react-split__sash--horizontal .split-sash-content {\n    height: 1px;\n    width: 100%;\n    background: var(--color-border);\n}\n\n/* Hover and active — accent highlight, slightly thicker */\n\n@media (pointer: fine) {\n    .react-split__sash--vertical .split-sash-content-active,\n    .react-split__sash--vertical:hover .split-sash-content {\n        width: 2px;\n        background: var(--color-accent);\n    }\n}\n\n@media (pointer: fine) {\n    .react-split__sash--horizontal .split-sash-content-active,\n    .react-split__sash--horizontal:hover .split-sash-content {\n        height: 2px;\n        background: var(--color-accent);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
